import apiBase from "./api-base";

export default class GetRestaurant extends apiBase {
  constructor(store) {
    const path = "ClientDashboard";
    super(store, path);
  }


  UploadMenuboardBackground(model, TVid, showProgress) {
    return this._request({
      action: `UploadMenuboardBackground`,
      method: "POST",
      body: model,
      showProgress,
      params: {
        id: TVid,
      },
    });
  }
  DuplicateMenu(model) {
    return this._request({
      action: `DuplicateMenu`,
      method: "POST",
      body: model,
    });
  }
  UpdatePOSShowTipOnReader(model) {
    return this._request({
      action: `UpdatePOSShowTipOnReader`,
      method: "POST",
      body: model,
    });
  }
  DuplicateCategory(model) {
    return this._request({
      action: `DuplicateCategory`,
      method: "POST",
      body: model,
    });
  }
  DeleteMenuboardBackground(model, TVid, showProgress) {
    return this._request({
      action: `DeleteMenuboardBackground`,
      method: "POST",
      body: model,
      showProgress,
      params: {
        id: TVid,
      },
    });
  }
  DuplicateItem(model) {
    return this._request({
      action: `DuplicateItem`,
      method: "POST",
      body: model,
      headers: {
        UserID: model.UserID,
      },
    });
  } 
  SendShiftReportPrintToApp(model) {
    return this._request({
      action: "SendShiftReportPrintToApp",
      method: "POST",
      body: model,
    });
  }
  DeleteRestaurantOrder(model) {
    return this._request({
      action: "DeleteRestaurantOrder",
      method: "POST",
      body: model,
    });
  }
  UpdateRestaurantAutomatic_Logout_Time_Threshold(model) {
    return this._request({
      action: "UpdateRestaurantAutomatic_Logout_Time_Threshold",
      method: "POST",
      body: model,
    });
  }
  UpdateKioskConfig(model) {
    return this._request({
      action: "UpdateKioskConfig",
      method: "POST",
      body: model,
    });
  }
  DeleteRestaurantAd(model) {
    return this._request({
      action: "DeleteRestaurantAd",
      method: "DELETE",
      body: model,
    });
  }
  UpdateTicketTabAcknowledged(model) {
    return this._request({
      action: "UpdateTicketTabAcknowledged",
      method: "DELETE",
      body: model,
    });
  }
  UpdateRestaurantAd(model) {
    return this._request({
      action: "UpdateRestaurantAd",
      method: "PATCH",
      body: model,
    });
  }
  CreateRestaurantAd(model) {
    return this._request({
      action: "CreateRestaurantAd",
      method: "POST",
      body: model,
    });
  }
  UpdatePickupPackType(model) {
    return this._request({
      action: "UpdatePickupPackType",
      method: "POST",
      body: model,
    });
  }
  UpdateKioskLanguage(model) {
    return this._request({
      action: "UpdateKioskLanguage",
      method: "POST",
      body: model,
    });
  }
  GetKioskLanguage(model) {
    return this._request({
      action: "GetKioskLanguage",
      method: "GET",
      params: model,
    });
  }
  GetKioskDisplayMode() {
    return this._request({
      action: "GetKioskDisplayMode",
      method: "GET",
    });
  }
  UpdateMenuFocus(model) {
    return this._request({
      action: "UpdateMenuFocus",
      method: "POST",
      body: model,
    });
  }
  GetPickupPackTypes(params) {
    return this._request({
      action: "GetPickupPackTypes",
      method: "GET",
      params: params,
    });
  }

  SendFireBaseOpenCashBoxMessage(filter) {
    return this._request({
      action: "SendFireBaseOpenCashBoxMessage",
      method: "GET",
      params: filter,
    });
  }
  GetOtherPaySource(filter) {
    return this._request({
      action: "GetOtherPaySource",
      method: "GET",
      params: filter,
    });
  }
  UpdateOtherPaySource(model) {
    return this._request({
      action: "UpdateOtherPaySource",
      method: "POST",
      body: model,
    });
  }
  GetDashBoardRestaurantOrdersBeepTicket(filter) {
    return this._request({
      action: "GetDashBoardRestaurantOrdersBeepTicket",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantAds(id) {
    return this._request({
      action: "GetRestaurantAds",
      method: "GET",
      params: id,
    });
  }
  GetRestaurantMenuboardPermission(filter) {
    return this._request({
      action: "GetRestaurantMenuboardPermission",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantMenuboardTVs(filter) {
    return this._request({
      action: "GetRestaurantMenuboardTVs",
      method: "GET",
      params: filter,
    });
  }
  DeleteMenuboardTVDisplayTemplate(model) {
    return this._request({
      action: "DeleteMenuboardTVDisplayTemplate",
      method: "POST",
      body: model,
    });
  }
  UpdateRestaurantMenuboardTV(model) {
    return this._request({
      action: "UpdateRestaurantMenuboardTV",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantCDPList(filter) {
    return this._request({
      action: "GetRestaurantCDPList",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantPOSlocation(filter) {
    return this._request({
      action: "GetRestaurantPOSlocation",
      method: "GET",
      params: filter,
    });
  }
  getList(showProgress) {
    return this._request({
      action: "getrestaurantname",
      method: "GET",
      showProgress,
    });
  }

  SendOrderPrintToApp(model) {
    return this._request({
      action: "SendOrderPrintToApp",
      method: "POST",
      body: model,
    });
  }

  GetRestaurantOrders(filter, showProgress) {
    return this._request({
      action: "GetRestaurantOrders",
      method: "GET",
      params: filter,
      showProgress,
    });
  }

  GetOrderDetailKDSPrinter(filter, showProgress) {
    return this._request({
      action: "GetOrderDetailKDSPrinter",
      method: "GET",
      params: filter,
      showProgress,
    });
  }

  GetRestaurantCurrentOrders(filter) {
    return this._request({
      action: "GetRestaurantCurrentOrders",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantOrderDetail(filter) {
    return this._request({
      action: "GetRestaurantOrderDetail",
      method: "GET",
      params: filter,
    });
  }
  login(model) {
    return this._request({
      action: "DashboardLogin",
      method: "POST",
      body: model,
    });
  }

  UpdateOrderDetailKDSPrinter(model) {
    return this._request({
      action: "UpdateOrderDetailKDSPrinter",
      method: "POST",
      body: model,
    });
  }

  GetRestaurantPreparationTime(filter) {
    return this._request({
      action: "GetRestaurantPreparationTime",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantPreparationTime(model) {
    return this._request({
      action: "UpdateRestaurantPreparationTime",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantTax(filter) {
    return this._request({
      action: "GetRestaurantTax",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantTax(model) {
    return this._request({
      action: "UpdateRestaurantTax",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantAllowance(filter) {
    return this._request({
      action: "GetRestaurantAllowance",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantAllowance(model) {
    return this._request({
      action: "UpdateOrderAllowance",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantQRCode(filter) {
    return this._request({
      action: "GetRestaurantQRCode",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantMenuEditURL(filter) {
    return this._request({
      action: "GetRestaurantMenuEditURL",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantRestauranteurID (filter) {
    return this._request({
      action: "GetRestaurantRestauranteurID",
      method: "GET",
      params: filter,
    });
  }
  UpdateOrderCredit(model) {
    return this._request({
      action: "UpdateOrderCredit",
      method: "POST",
      body: model,
    });
  }
  RefundOrder(model) {
    return this._request({
      action: "RefundOrder",
      method: "POST",
      body: model,
    });
  }
  RefundOrder_Cash(model) {
    return this._request({
      action: "RefundOrder_Cash",
      method: "POST",
      body: model,
    });
  }
  UpdateOrderStatus(model) {
    return this._request({
      action: "UpdateOrderStatus",
      method: "POST",
      body: model,
    });
  }
  UpdateOrderDetailsStatus(model) {
    return this._request({
      action: "UpdateOrderDetailsStatus",
      method: "POST",
      body: model,
    });
  }
  UpdateOrderDetailsStatusMultiple(model) {
    return this._request({
      action: "UpdateOrderDetailsStatusMultiple",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantCurrentOrderDetail(filter) {
    return this._request({
      action: "GetRestaurantCurrentOrderDetail",
      method: "POST",
      params: filter,
    });
  }
  GetOrderCancelReason() {
    return this._request({
      action: "GetOrderCancelReason",
      method: "GET",
    });
  }
  GetCurrentUserInfo() {
    return this._request({
      action: "GetCurrentUserInfo",
      method: "GET",
    });
  }
  GetSMSMessages() {
    return this._request({
      action: "GetSMSMessages",
      method: "GET",
    });
  }

  GetRestaurantOrders(filter, showProgress) {
    return this._request({
      action: "GetRestaurantOrders",
      method: "GET",
      params: filter,
      showProgress,
    });
  }
  GetDashBoardRestaurantOrdersBeep(filter, showProgress) {
    return this._request({
      action: "GetDashBoardRestaurantOrdersBeep",
      method: "GET",
      params: filter,
      showProgress,
    });
  }
  GetDashBoardRestaurantOrdersBeep_Event(filter, showProgress) {
    return this._request({
      action: "GetDashBoardRestaurantOrdersBeep_Event",
      method: "GET",
      params: filter,
      showProgress,
    });
  }
  GetRestaurantCurrentOrders(filter) {
    return this._request({
      action: "GetRestaurantCurrentOrders",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantOrderDetail(filter) {
    return this._request({
      action: "GetRestaurantOrderDetail",
      method: "GET",
      params: filter,
    });
  }
  login(model) {
    return this._request({
      action: "DashboardLogin",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantPreparationTime(filter) {
    return this._request({
      action: "GetRestaurantPreparationTime",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantPreparationTime(model) {
    return this._request({
      action: "UpdateRestaurantPreparationTime",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantTax(filter) {
    return this._request({
      action: "GetRestaurantTax",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantTax(model) {
    return this._request({
      action: "UpdateRestaurantTax",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantAllowance(filter) {
    return this._request({
      action: "GetRestaurantAllowance",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantAllowance(model) {
    return this._request({
      action: "UpdateOrderAllowance",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantQRCode(filter) {
    return this._request({
      action: "GetRestaurantQRCode",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantMenuEditURL(filter) {
    return this._request({
      action: "GetRestaurantMenuEditURL",
      method: "GET",
      params: filter,
    });
  }
  UpdateOrderCredit(model) {
    return this._request({
      action: "UpdateOrderCredit",
      method: "POST",
      body: model,
    });
  }
  RefundOrder(model) {
    return this._request({
      action: "RefundOrder",
      method: "POST",
      body: model,
    });
  }
  RefundOrder_Cash(model) {
    return this._request({
      action: "RefundOrder_Cash",
      method: "POST",
      body: model,
    });
  }
  UpdateOrderStatus(model) {
    return this._request({
      action: "UpdateOrderStatus",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantCurrentOrderDetail(filter) {
    return this._request({
      action: "GetRestaurantCurrentOrderDetail",
      method: "POST",
      params: filter,
    });
  }
  GetLogOut(filter) {
    return this._request({
      action: "GetLogOut",
      method: "GET",
      params: filter,
    });
  }
  GetActivePrinters(filter) {
    return this._request({
      action: "GetRestaurantPrinters",
      method: "GET",
      params: filter,
    });
  }
  GetOrderCancelReason() {
    return this._request({
      action: "GetOrderCancelReason",
      method: "GET",
    });
  }
  GetCurrentUserInfo() {
    return this._request({
      action: "GetCurrentUserInfo",
      method: "GET",
    });
  }
  GetSMSMessages() {
    return this._request({
      action: "GetSMSMessages",
      method: "GET",
    });
  }

  SendSMS(model) {
    return this._request({
      action: "SendSMS",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantDashboardStats1(filter) {
    return this._request({
      action: "GetRestaurantDashboardStats1",
      method: "POST",
      params: filter,
    });
  }
  CustomerSupport(model) {
    return this._request({
      action: "CustomerSupport",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantRestauranteurID(filter) {
    return this._request({
      action: "GetRestaurantRestauranteurID",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantMenuTypes(filter) {
    return this._request({
      action: "GetRestaurantMenuTypes",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantMenutypeDropDown(filter) {
    return this._request({
      action: "GetRestaurantMenutypeDropDown",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantItems(filter) {
    return this._request({
      action: "GetRestaurantItems",
      method: "GET",
      params: filter,
    });
  }
  UpdateDelOrderItem(model) {
    return this._request({
      action: "UpdateDelOrderItem",
      method: "POST",
      body: model,
    });
  }
  DeleteOrderItem(model) {
    return this._request({
      action: "DeleteOrderItem",
      method: "POST",
      body: model,
    });
  }
  UpdateOrderAddItem(model) {
    return this._request({
      action: "UpdateOrderAddItem",
      method: "POST",
      body: model,
    });
  }
  UpdateRestaurantPickupInfo(model) {
    return this._request({
      action: "UpdateRestaurantPickupInfo",
      method: "POST",
      body: model,
    });
  }
  UpdateOrderDetailsStatus(model) {
    return this._request({
      action: "UpdateOrderDetailsStatus",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantPickupPeriod(filter) {
    return this._request({
      action: "GetRestaurantPickupPeriod",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantCategoryModifier(filter) {
    return this._request({
      action: "GetRestaurantCategoryModifier",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantModifier(filter) {
    return this._request({
      action: "GetRestaurantModifier",
      method: "GET",
      params: filter,
    });
  }
  GetIsDuplicateModifierCategory(filter) {
    return this._request({
      action: "GetIsDuplicateModifierCategory",
      method: "GET",
      params: filter,
    });
  }
  UpdateInsertCategoryModifier(model) {
    return this._request({
      action: "UpdateInsertCategoryModifier",
      method: "POST",
      body: model,
    });
  }
  InsertModifier(model) {
    return this._request({
      action: "InsertModifier",
      method: "POST",
      body: model,
    });
  }
  UpdateModifier(model) {
    return this._request({
      action: "UpdateModifier",
      method: "POST",
      body: model,
    });
  }
  UpdateDelModifierCategory(model) {
    return this._request({
      action: "UpdateDelModifierCategory",
      method: "POST",
      body: model,
    });
  }
  UpdateDelModifier(model) {
    return this._request({
      action: "UpdateDelModifier",
      method: "POST",
      body: model,
    });
  }
  UpdateModifierCategoryRelation(model) {
    return this._request({
      action: "UpdateModifierCategoryRelation",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantPrinters(filter) {
    return this._request({
      action: "GetRestaurantPrinters",
      method: "GET",
      params: filter,
    });
  }
  UpdatePrinters(model) {
    return this._request({
      action: "UpdatePrinters",
      method: "POST",
      body: model,
    });
  }

  DeletePrinter(model) {
    return this._request({
      action: "DeletePrinter",
      method: "POST",
      body: model,
    });
  }

  UpdatePrinterStatus(model) {
    return this._request({
      action: "UpdatePrinterStatus",
      method: "POST",
      body: model,
    });
  }
  CreateRestaurantPrinter(model) {
    return this._request({
      action: "CreateRestaurantPrinter",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantKDSs(filter) {
    return this._request({
      action: "GetRestaurantKDSs",
      method: "GET",
      params: filter,
    });
  }

  InsertKDSName(model) {
    return this._request({
      action: "InsertKDSName",
      method: "POST",
      body: model,
    });
  }
  UpdateDeleteKDS(model) {
    return this._request({
      action: "UpdateDeleteKDS",
      method: "POST",
      body: model,
    });
  }
  UpdateKDSName(model) {
    return this._request({
      action: "UpdateKDSName",
      method: "POST",
      body: model,
    });
  }
  UpdateRestaurantPickupInfo_Event(model) {
    return this._request({
      action: "UpdateRestaurantPickupInfo_Event",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantOrderURL(filter) {
    return this._request({
      action: "GetRestaurantOrderURL",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantShortURLid(model) {
    return this._request({
      action: "UpdateRestaurantShortURLid",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantOrders_Event(filter) {
    return this._request({
      action: "GetRestaurantOrders_Event",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantDeliverySetting(filter) {
    return this._request({
      action: "GetRestaurantDeliverySetting",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantDeliveryPeriod(filter) {
    return this._request({
      action: "GetRestaurantDeliveryPeriod",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantDeliveryFee(model) {
    return this._request({
      action: "UpdateRestaurantDeliveryFee",
      method: "POST",
      body: model,
    });
  }
  UpdateRestaurantDeliveryInfo(model) {
    return this._request({
      action: "UpdateRestaurantDeliveryInfo",
      method: "POST",
      body: model,
    });
  }
  GetModifierByFoodID(filter) {
    return this._request({
      action: "GetModifierByFoodID",
      method: "GET",
      params: filter,
    });
  }
  GetServerPrinterIP(filter) {
    return this._request({
      action: "GetServerPrinterIP",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantPrinterServerIP(model) {
    return this._request({
      action: "UpdateRestaurantPrinterServerIP",
      method: "POST",
      body: model,
    });
  }
  GetOrderCartInfo(filter) {
    return this._request({
      action: "GetOrderCartInfo",
      method: "GET",
      params: filter,
    });
  }

  GetRestaurantOrders(filter, showProgress) {
    return this._request({
      action: "GetRestaurantOrders",
      method: "GET",
      params: filter,
      showProgress,
    });
  }
  GetRestaurantCurrentOrders(filter) {
    return this._request({
      action: "GetRestaurantCurrentOrders",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantOrderDetail(filter) {
    return this._request({
      action: "GetRestaurantOrderDetail",
      method: "GET",
      params: filter,
    });
  }
  login(model) {
    return this._request({
      action: "DashboardLogin",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantPreparationTime(filter) {
    return this._request({
      action: "GetRestaurantPreparationTime",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantPreparationTime(model) {
    return this._request({
      action: "UpdateRestaurantPreparationTime",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantTax(filter) {
    return this._request({
      action: "GetRestaurantTax",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantTax(model) {
    return this._request({
      action: "UpdateRestaurantTax",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantAllowance(filter) {
    return this._request({
      action: "GetRestaurantAllowance",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantAllowance(model) {
    return this._request({
      action: "UpdateOrderAllowance",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantQRCode(filter) {
    return this._request({
      action: "GetRestaurantQRCode",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantMenuEditURL(filter) {
    return this._request({
      action: "GetRestaurantMenuEditURL",
      method: "GET",
      params: filter,
    });
  }
  UpdateOrderCredit(model) {
    return this._request({
      action: "UpdateOrderCredit",
      method: "POST",
      body: model,
    });
  }
  RefundOrder(model) {
    return this._request({
      action: "RefundOrder",
      method: "POST",
      body: model,
    });
  }
  RefundOrder_Cash(model) {
    return this._request({
      action: "RefundOrder_Cash",
      method: "POST",
      body: model,
    });
  }
  UpdateOrderStatus(model) {
    return this._request({
      action: "UpdateOrderStatus",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantCurrentOrderDetail(filter) {
    return this._request({
      action: "GetRestaurantCurrentOrderDetail",
      method: "POST",
      params: filter,
    });
  }
  
  GetOrderCancelReason() {
    return this._request({
      action: "GetOrderCancelReason",
      method: "GET",
    });
  }
  GetCurrentUserInfo() {
    return this._request({
      action: "GetCurrentUserInfo",
      method: "GET",
    });
  }
  GetSMSMessages() {
    return this._request({
      action: "GetSMSMessages",
      method: "GET",
    });
  }

  GetRestaurantOrders(filter, showProgress) {
    return this._request({
      action: "GetRestaurantOrders",
      method: "GET",
      params: filter,
      showProgress,
    });
  }
  GetRestaurantCurrentOrders(filter) {
    return this._request({
      action: "GetRestaurantCurrentOrders",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantOrderDetail(filter) {
    return this._request({
      action: "GetRestaurantOrderDetail",
      method: "GET",
      params: filter,
    });
  }
  login(model) {
    return this._request({
      action: "DashboardLogin",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantPreparationTime(filter) {
    return this._request({
      action: "GetRestaurantPreparationTime",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantPreparationTime(model) {
    return this._request({
      action: "UpdateRestaurantPreparationTime",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantTax(filter) {
    return this._request({
      action: "GetRestaurantTax",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantTax(model) {
    return this._request({
      action: "UpdateRestaurantTax",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantAllowance(filter) {
    return this._request({
      action: "GetRestaurantAllowance",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantAllowance(model) {
    return this._request({
      action: "UpdateOrderAllowance",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantQRCode(filter) {
    return this._request({
      action: "GetRestaurantQRCode",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantMenuEditURL(filter) {
    return this._request({
      action: "GetRestaurantMenuEditURL",
      method: "GET",
      params: filter,
    });
  }
  UpdateOrderCredit(model) {
    return this._request({
      action: "UpdateOrderCredit",
      method: "POST",
      body: model,
    });
  }
  RefundOrder(model) {
    return this._request({
      action: "RefundOrder",
      method: "POST",
      body: model,
    });
  }
  RefundOrder_Cash(model) {
    return this._request({
      action: "RefundOrder_Cash",
      method: "POST",
      body: model,
    });
  }
  UpdateOrderStatus(model) {
    return this._request({
      action: "UpdateOrderStatus",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantCurrentOrderDetail(filter) {
    return this._request({
      action: "GetRestaurantCurrentOrderDetail",
      method: "POST",
      params: filter,
    });
  }
  
  GetOrderCancelReason() {
    return this._request({
      action: "GetOrderCancelReason",
      method: "GET",
    });
  }
  GetCurrentUserInfo() {
    return this._request({
      action: "GetCurrentUserInfo",
      method: "GET",
    });
  }
  GetSMSMessages() {
    return this._request({
      action: "GetSMSMessages",
      method: "GET",
    });
  }

  SendSMS(model) {
    return this._request({
      action: "SendSMS",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantDashboardStats1(filter) {
    return this._request({
      action: "GetRestaurantDashboardStats1",
      method: "POST",
      params: filter,
    });
  }
  CustomerSupport(model) {
    return this._request({
      action: "CustomerSupport",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantRestauranteurID(filter) {
    return this._request({
      action: "GetRestaurantRestauranteurID",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantMenuTypes(filter) {
    return this._request({
      action: "GetRestaurantMenuTypes",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantItems(filter) {
    return this._request({
      action: "GetRestaurantItems",
      method: "GET",
      params: filter,
    });
  }
  UpdateDelOrderItem(model) {
    return this._request({
      action: "UpdateDelOrderItem",
      method: "POST",
      body: model,
    });
  }
  DeleteOrderItem(model) {
    return this._request({
      action: "DeleteOrderItem",
      method: "POST",
      body: model,
    });
  }
  UpdateOrderAddItem(model) {
    return this._request({
      action: "UpdateOrderAddItem",
      method: "POST",
      body: model,
    });
  }
  UpdateRestaurantPickupInfo(model) {
    return this._request({
      action: "UpdateRestaurantPickupInfo",
      method: "POST",
      body: model,
    });
  }
  UpdateOrderDetailsStatus(model) {
    return this._request({
      action: "UpdateOrderDetailsStatus",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantPickupPeriod(filter) {
    return this._request({
      action: "GetRestaurantPickupPeriod",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantCategoryModifier(filter) {
    return this._request({
      action: "GetRestaurantCategoryModifier",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantModifier(filter) {
    return this._request({
      action: "GetRestaurantModifier",
      method: "GET",
      params: filter,
    });
  }
  GetIsDuplicateModifierCategory(filter) {
    return this._request({
      action: "GetIsDuplicateModifierCategory",
      method: "GET",
      params: filter,
    });
  }
  UpdateInsertCategoryModifier(model) {
    return this._request({
      action: "UpdateInsertCategoryModifier",
      method: "POST",
      body: model,
    });
  }
  InsertModifier(model) {
    return this._request({
      action: "InsertModifier",
      method: "POST",
      body: model,
    });
  }
  UpdateModifier(model) {
    return this._request({
      action: "UpdateModifier",
      method: "POST",
      body: model,
    });
  }
  UpdateDelModifierCategory(model) {
    return this._request({
      action: "UpdateDelModifierCategory",
      method: "POST",
      body: model,
    });
  }
  UpdateDelModifier(model) {
    return this._request({
      action: "UpdateDelModifier",
      method: "POST",
      body: model,
    });
  }
  UpdateModifierCategoryRelation(model) {
    return this._request({
      action: "UpdateModifierCategoryRelation",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantPrinters(filter) {
    return this._request({
      action: "GetRestaurantPrinters",
      method: "GET",
      params: filter,
    });
  }
  UpdatePrinters(model) {
    return this._request({
      action: "UpdatePrinters",
      method: "POST",
      body: model,
    });
  }

  DeletePrinter(model) {
    return this._request({
      action: "DeletePrinter",
      method: "POST",
      body: model,
    });
  }

  UpdatePrinterStatus(model) {
    return this._request({
      action: "UpdatePrinterStatus",
      method: "POST",
      body: model,
    });
  }
  CreateRestaurantPrinter(model) {
    return this._request({
      action: "CreateRestaurantPrinter",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantKDSs(filter) {
    return this._request({
      action: "GetRestaurantKDSs",
      method: "GET",
      params: filter,
    });
  }

  InsertKDSName(model) {
    return this._request({
      action: "InsertKDSName",
      method: "POST",
      body: model,
    });
  }
  UpdateDeleteKDS(model) {
    return this._request({
      action: "UpdateDeleteKDS",
      method: "POST",
      body: model,
    });
  }
  UpdateKDSName(model) {
    return this._request({
      action: "UpdateKDSName",
      method: "POST",
      body: model,
    });
  }
  UpdateRestaurantPickupInfo_Event(model) {
    return this._request({
      action: "UpdateRestaurantPickupInfo_Event",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantOrderURL(filter) {
    return this._request({
      action: "GetRestaurantOrderURL",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantShortURLid(model) {
    return this._request({
      action: "UpdateRestaurantShortURLid",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantOrders_Event(filter) {
    return this._request({
      action: "GetRestaurantOrders_Event",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantDeliverySetting(filter) {
    return this._request({
      action: "GetRestaurantDeliverySetting",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantDeliveryPeriod(filter) {
    return this._request({
      action: "GetRestaurantDeliveryPeriod",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantDeliveryFee(model) {
    return this._request({
      action: "UpdateRestaurantDeliveryFee",
      method: "POST",
      body: model,
    });
  }
  UpdateRestaurantDeliveryInfo(model) {
    return this._request({
      action: "UpdateRestaurantDeliveryInfo",
      method: "POST",
      body: model,
    });
  }
  GetModifierByFoodID(filter) {
    return this._request({
      action: "GetModifierByFoodID",
      method: "GET",
      params: filter,
    });
  }
  GetServerPrinterIP(filter) {
    return this._request({
      action: "GetServerPrinterIP",
      method: "GET",
      params: filter,
    });
  }
  UpdateRestaurantPrinterServerIP(model) {
    return this._request({
      action: "UpdateRestaurantPrinterServerIP",
      method: "POST",
      body: model,
    });
  }
  GetOrderCartInfo(filter) {
    return this._request({
      action: "GetOrderCartInfo",
      method: "GET",
      params: filter,
    });
  }

  SendOTP(model) {
    return this._request({
      action: "SendOTP",
      method: "POST",
      body: model,
    });
  }
  VerifyOTP(model) {
    return this._request({
      action: "VerifyOTP",
      method: "POST",
      body: model,
    });
  }
  CreateOrder(model) {
    return this._request({
      action: "CreateOrder",
      method: "POST",
      body: model,
    });
  }

  GetPickupTimes(filter) {
    return this._request({
      action: "GetPickupTimes",
      method: "GET",
      params: filter,
    });
  }
  GetPickupDateByMenu(filter) {
    return this._request({
      action: "GetPickupDateByMenu",
      method: "GET",
      params: filter,
    });
  }
  GetPickupTimes_Event(filter) {
    return this._request({
      action: "GetPickupTimes_Event",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantDeliveryFee(filter) {
    return this._request({
      action: "GetRestaurantDeliveryFee",
      method: "GET",
      params: filter,
    });
  }
  GetDeliveryTimes(filter) {
    return this._request({
      action: "GetDeliveryTimes",
      method: "GET",
      params: filter,
    });
  }
  AddPaymentMethod(model) {
    return this._request({
      action: "AddPaymentMethod",
      method: "POST",
      body: model,
    });
  }
  PayOrder(model) {
    return this._request({
      action: "PayOrder",
      method: "POST",
      body: model,
    });
  }
  UpdateTransaction(model) {
    return this._request({
      action: "UpdateTransaction",
      method: "POST",
      body: model,
    });
  }

  GetOrderPaymentURL(filter) {
    return this._request({
      action: "GetOrderPaymentURL",
      method: "GET",
      params: filter,
    });
  }

  SendEmailReceipt(model) {
    return this._request({
      action: "SendEmailReceipt",
      method: "POST",
      body: model,
    });
  }

  GetRestaurantItemAvailability(filter) {
    return this._request({
      action: "GetRestaurantItemAvailability",
      method: "GET",
      params: filter,
    });
  }
  UpdateItemAvailability(model) {
    return this._request({
      action: "UpdateItemAvailability",
      method: "POST",
      body: model,
    });
  }
  DeleteItemAvailability(model) {
    return this._request({
      action: "DeleteItemAvailability",
      method: "POST",
      body: model,
    });
  }
  UpdateOrderCashPaid(model) {
    return this._request({
      action: "UpdateOrderCashPaid",
      method: "POST",
      body: model,
    });
  }
  UpdateOrderTableNumber(model) {
    return this._request({
      action: "UpdateOrderTableNumber",
      method: "POST",
      body: model,
    });
  }
  UpdateItemPrintingStaus(model) {
    return this._request({
      action: "UpdateItemPrintingStaus",
      method: "POST",
      body: model,
    });
  }
  
  
  GetItemAvailability(filter) {
    return this._request({
      action: "GetItemAvailability",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantTableID(filter) {
    return this._request({
      action: "GetRestaurantTableID",
      method: "GET",
      params: filter,
    });
  }

  InsertRestaurantTableID(model) {
    return this._request({
      action: "InsertRestaurantTableID",
      method: "POST",
      body: model,
    });
  }
  UpdateRestaurantTableID(model) {
    return this._request({
      action: "UpdateRestaurantTableID",
      method: "POST",
      body: model,
    });
  }
  DeleteRestaurantTableID(model) {
    return this._request({
      action: "DeleteRestaurantTableID",
      method: "POST",
      body: model,
    });
  }
  UpdateRestaurantQRCode(model) {
    return this._request({
      action: "UpdateRestaurantQRCode",
      method: "POST",
      body: model,
    });
  }
  GetRestaurantQRCodes(filter) {
    return this._request({
      action: "GetRestaurantQRCodes",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantPOSs(filter) {
    return this._request({
      action: "GetRestaurantPOSs",
      method: "GET",
      params: filter,
    });
  }
  GetDisplayConfigs(filter) {
    return this._request({
      action: "GetDisplayConfigs",
      method: "GET",
      params: filter,
    });
  }
  GetRestaurantProfile(filter) {
    return this._request({
      action: "GetRestaurantProfile",
      method: "GET",
      params: filter,
    });
  }
  RegisterPOS(model) {
    return this._request({
      action: "RegisterPOS",
      method: "POST",
      body: model,
    });
  }
  UpdateRestaurantPOS(model) {
    return this._request({
      action: "UpdateRestaurantPOS",
      method: "POST",
      body: model,
    });
  }
  DeleteRestaurantPOS(model) {
    return this._request({
      action: "DeleteRestaurantPOS",
      method: "POST",
      body: model,
    });
  }
  ConnectionToken(model) {
    return this._request({
      action: "ConnectionToken",
      method: "POST",
      body: model,
    });
  }
  CreatePaymentIntent(model) {
    return this._request({
      action: "CreatePaymentIntent",
      method: "POST",
      body: model,
    });
  }
  CapturePaymentIntent(model) {
    return this._request({
      action: "CapturePaymentIntent",
      method: "POST",
      body: model,
    });
  }
  ProcessPaymentIntent(model) {
    return this._request({
      action: "ProcessPaymentIntent",
      method: "POST",
      body: model,
    });
  }
  GetReaderStatus(model) {
    return this._request({
      action: "GetReaderStatus",
      method: "POST",
      body: model,
    });
  }
  CancelReaderAction(model) {
    return this._request({
      action: "CancelReaderAction",
      method: "POST",
      body: model,
    });
  }
  SplitRestaurantOrderyItem(model) {
    return this._request({
      action: "SplitRestaurantOrderyItem",
      method: "POST",
      body: model,
    });
  }

  SplitRestaurantOrderByAmount(model) {
    return this._request({
      action: "SplitRestaurantOrderByAmount",
      method: "POST",
      body: model,
    });
  }

  SplitRestaurantAvailableParty(filter) {
    return this._request({
      action: "SplitRestaurantAvailableParty",
      method: "GET",
      params: filter,
    });
  }

  // Restaurant Profile
  UpdateRestaurantProfile(model) {
    return this._request({
      action: "UpdateRestaurantProfile",
      method: "POST",
      body: model,
    });
  }

  GetRestaurantProfile(model) {
    {
      return this._request({
        action: "GetRestaurantProfile",
        method: "GET",
        params: model,
      });
    }
  }
  UpdateServices(model) {
    {
      return this._request({
        action: "UpdateServices",
        method: "POST",
        body: model,
      });
    }
  }

  UploadLogoPhoto(model) {
    {
      return this._request({
        action: "UploadLogoPhoto",
        method: "POST",
        body: model,
      });
    }
  }
  UploadCoverPhoto(model) {
    {
      return this._request({
        action: "UploadCoverPhoto",
        method: "POST",
        body: model,
      });
    }
  }

  DeleteLogoImage(model) {
    {
      return this._request({
        action: "DeleteLogoPhoto",
        method: "POST",
        body: model,
      });
    }
  }
  DeleteCoverImage(model) {
    {
      return this._request({
        action: "DeleteCoverPhoto",
        method: "POST",
        body: model,
      });
    }
  }
  UpdateWorkingHours(model) {
    {
      return this._request({
        action: "UpdateWorkingHours",
        method: "POST",
        body: model,
      });
    }
  }
  InsertRestaurantUser(model) {
    {
      return this._request({
        action: "InsertRestaurantUser",
        method: "POST",
        body: model,
      });
    }
  }
  DeleteRestaurantUser(model) {
    {
      return this._request({
        action: "DeleteRestaurantUser",
        method: "POST",
        body: model,
      });
    }
  }
  UpdateRestaurantUser(model) {
    {
      return this._request({
        action: "UpdateRestaurantUser",
        method: "POST",
        body: model,
      });
    }
  }
  CheckClientEmail(model) {
    {
      return this._request({
        action: "CheckClientEmail",
        method: "POST",
        body: model,
      });
    }
  }
  UpdateOrderServerName(model) {
    {
      return this._request({
        action: "UpdateOrderServerName",
        method: "POST",
        body: model,
      });
    }
  }
  UndoSplitRestaurantOrders(model) {
    {
      return this._request({
        action: "UndoSplitRestaurantOrders",
        method: "POST",
        body: model,
      });
    }
  }
  UpdateOrderDetailsStatusMultiple(model) {
    {
      return this._request({
        action: "UpdateOrderDetailsStatusMultiple",
        method: "POST",
        body: model,
      });
    }
  }
  GetDashboardRestaurantClient(filter) {
    {
      return this._request({
        action: "GetDashboardRestaurantClient",
        method: "GET",
        params: filter,
      });
    }
  }
  GetDashboardClientRole(filter) {
    {
      return this._request({
        action: "GetDashboardClientRole",
        method: "GET",
        params: filter,
      });
    }
  }
  GetRestaurantOrderServer(filter) {
    {
      return this._request({
        action: "GetRestaurantOrderServer",
        method: "GET",
        params: filter,
      });
    }
  }
  GetRestaurantOpenItems (filter) {
    {
      return this._request({
        action: "GetRestaurantOpenItems",
        method: "GET",
        params: filter,
      });
    }
  }
  GetRestaurantShiftReport (filter) {
    {
      return this._request({
        action: "GetRestaurantShiftReport",
        method: "GET",
        params: filter,
      });
    }
  }
  GetOtherPaymentBreakdown (filter) {
    {
      return this._request({
        action: "GetOtherPaymentBreakdown",
        method: "GET",
        params: filter,
      });
    }
  }
  GetRestaurantReportServer (filter) {
    {
      return this._request({
        action: "GetRestaurantReportServer",
        method: "GET",
        params: filter,
      });
    }
  }
  GetRestaurantOrdersDetailedList (filter) {
    {
      return this._request({
        action: "GetRestaurantOrdersDetailedList",
        method: "GET",
        params: filter,
      });
    }
  }
  GetOrderItemsByDueDate_Event (filter) {
    {
      return this._request({
        action: "GetOrderItemsByDueDate_Event",
        method: "GET",
        params: filter,
      });
    }
  }
  GetMenuTypes (filter) {
    {
      return this._request({
        action: "GetMenuTypes",
        method: "GET",
        params: filter,
      });
    }
  }
  CreateMenuType (model) {
    {
      return this._request({
        action: "CreateMenuType",
        method: "POST",
        body: model,
      });
    }
  }
  UpdateMenuType (model) {
    {
      return this._request({
        action: "UpdateMenuType",
        method: "POST",
        body: model,
      });
    }
  }
  DeleteMenuType (model) {
    {
      return this._request({
        action: "DeleteMenuType",
        method: "POST",
        body: model,
      });
    }
  }
  MergeRestaurantOrders (model) {
    {
      return this._request({
        action: "MergeRestaurantOrders",
        method: "POST",
        body: model,
      });
    }
  }
  UpdateItemCourse (model) {
    {
      return this._request({
        action: "UpdateItemCourse",
        method: "POST",
        body: model,
      });
    }
  }
  UpdateOrderTaxExemption (model) {
    {
      return this._request({
        action: "UpdateOrderTaxExemption",
        method: "POST",
        body: model,
      });
    }
  }
  UpdateRestaurantLanLat (model) {
    {
      return this._request({
        action: "UpdateRestaurantLanLat ",
        method: "POST",
        body: model,
      });
    }
  }
  GetRestaurantOpenTickets (filter) {
    {
      return this._request({
        action: "GetRestaurantOpenTickets",
        method: "GET",
        params: filter,
      });
    }
  }
  GetRestaurantProcessedTickets (filter) {
    {
      return this._request({
        action: "GetRestaurantProcessedTickets",
        method: "GET",
        params: filter,
      });
    }
  }
  GetRestaurantKioskStats1 (filter) {
    {
      return this._request({
        action: "GetRestaurantKioskStats1",
        method: "GET",
        params: filter,
      });
    }
  }
  GetRestaurantApprovalManager (filter) {
    {
      return this._request({
        action: "GetRestaurantApprovalManager",
        method: "GET",
        params: filter,
      });
    }
  }

  UpdateRestaurantFirebaseUsers (model) {
    {
      return this._request({
        action: "UpdateRestaurantFirebaseUsers",
        method: "POST",
        body: model,
      });
    }
  }
  SendApprovalCode (model) {
    {
      return this._request({
        action: "SendApprovalCode",
        method: "POST",
        body: model,
      });
    }
  }
  
  ProceedVerificationApprovalCode (model) {
    {
      return this._request({
        action: "ProceedVerificationApprovalCode",
        method: "POST",
        body: model,
      });
    }
  }

}
